import { useMutation } from "@tanstack/react-query";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Switch,
  message,
} from "antd";
import { useState } from "react";
import { addSubscription, updateSubscription } from "../../utils/api";

const AddSubscription = ({
  refech,

  update,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation(
    async (values) =>
      update
        ? await updateSubscription(update._id, values)
        : await addSubscription(values),
    {
      onSuccess: () => {
        messageApi.success(`Added`);
        //reset form
        !update && form.resetFields();
        refech();
        setVisible(false);
      },
      onError: (err) => {
        messageApi.error(err?.response?.data?.message);
      },
    }
  );
  const reward = Form.useWatch("isReward", form);
  return (
    <div>
      {contextHolder}
      <Button
        style={{
          width: "100%",
        }}
        type="primary"
        onClick={() => setVisible(true)}
      >
        {update ? "Update" : "Add"}
      </Button>
      <Modal
        title={update ? "Update " : "Add  "}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 8 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          initialValues={
            update && {
              name: update.name,
              description: update.description,
              price: update.price,
              validity: update.validity,
              isReward: update.isReward,
              musicRewardCoin: update.musicRewardCoin,
              videoRewardCoin: update.videoRewardCoin,
            }
          }
          onFinish={(values) => {
            console.log(values);

            mutate(values);
          }}
        >
          {" "}
          <Form.Item
            label="Name"
            name="name"
            required
            rules={[
              {
                required: true,
                message: "Please input your title",
              },
            ]}
          >
            <Input style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label="Description"
            name={"description"}
            rules={[{ required: true, message: "description is required" }]}
          >
            <Select placeholder="Select" mode="tags" />
          </Form.Item>
          <Form.Item
            label="Price"
            name="price"
            required
            rules={[
              {
                required: true,
                message: "Please input your price",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label="Validity"
            name="validity"
            required
            rules={[
              {
                required: true,
                message: "Please input your validity",
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            label="Reward"
            name="isReward"
            required
            rules={[
              {
                required: true,
                message: "Please input your reward",
              },
            ]}
          >
            <Switch
              checkedChildren="Yes"
              unCheckedChildren="No"
              checked={reward}
            />
          </Form.Item>
          {reward && (
            <>
              {" "}
              <Form.Item
                label="Music Reward Coin"
                name="musicRewardCoin"
                required
                rules={[
                  {
                    required: true,
                    message: "Please input your music reward coin",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                label="Video Reward Coin"
                name="videoRewardCoin"
                required
                rules={[
                  {
                    required: true,
                    message: "Please input your video reward coin",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </>
          )}
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default AddSubscription;
